import { render, staticRenderFns } from "./HomeStaff.vue?vue&type=template&id=8b93dc7e&scoped=true&"
import script from "./HomeStaff.vue?vue&type=script&lang=js&"
export * from "./HomeStaff.vue?vue&type=script&lang=js&"
import style0 from "./HomeStaff.vue?vue&type=style&index=0&id=8b93dc7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b93dc7e",
  null
  
)

export default component.exports